import { createFileRoute, redirect } from "@tanstack/react-router";

/** Superseded by the console account level. */
export const Route = createFileRoute("/dashboard/")({
  beforeLoad: () => {
    throw redirect({ to: "/console/home" });
  },
});
